import React from 'react';

import PropTypes from 'prop-types';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import fontawesome from '@fortawesome/fontawesome';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

fontawesome.library.add(fal, far, fas, fab);

class Icon extends React.PureComponent {
  render() {
    const { type, icon, ...props } = this.props;

    const iconType =
      {
        light: 'fal',
        regular: 'far',
        solid: 'fas',
        brand: 'fab'
      }[type] || 'fal';

    if (!props.className) {
      props.className = '';
    }

    props.className += ' img-fluid';

    return <FontAwesomeIcon icon={[iconType, icon]} {...props} />;
  }
}

Icon.propTypes = Object.assign({}, FontAwesomeIcon.propTypes, {
  icon: PropTypes.string,
  type: PropTypes.string
});

Icon.defaultProps = {
  icon: 'question-circle',
  type: 'light'
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/ui/Icon.js